export const storageNames = {
  localUserInfo: "switcher_user_info",
  sessionUserInfo: "switcher_user_info",
  localAuthData: "switcher_auth_data",
  sessionAuthData: "switcher_auth_data",
  currentRoute: "switcher_current_route",
};
